export interface LiveUpdateMessageBase extends Record<string, unknown> {
  Delay: number;
  RandomizationPeriod: number;
}

export interface LiveUpdateMessage extends LiveUpdateMessageBase {
  DealId: string;
  WeekOf: string;
}

export interface GroupFollowUpdateMessage extends Record<string, unknown> {
  dealId: string;
  action: GroupFollowActionType;
}

export interface AssignmentsUpdateMessage extends Record<string, unknown> {
  dealId: string;
  userIds: string[];
}

export enum GroupFollowActionType {
  groupFollow = 'group-followed',
  groupUnfollow = 'group-unfollowed',
}

export interface CasaUpdateMessage extends LiveUpdateMessageBase {
  Updates: string[];
}
